$(window).on('load', function () {
  const detailedSliders = $('.js-detail-slider')
  detailedSliders.each((idx, slider) => {
    if (slider.swiper) {
      slider.swiper.isLocked && slider.swiper.el.classList.add('is--locked')
    }
  })
})
